import type { WallboardQuery } from '@/features/wallboard/types/wallboard.types'
import { getSessionWallboard } from '@/api/services/sessionWallboard.service'
import { normalizeWallboardQuery } from '@/features/wallboard/utils/wallboardQuery'
import { usePermittedQuery } from '@/hooks/usePermittedQuery'

export const wallboardQueryKeys = {
  all: ['wallboard'] as const,
  list: (params: WallboardQuery | undefined) =>
    ['wallboard', 'list', normalizeWallboardQuery(params)] as const,
}

export function useWallboard(
  params: WallboardQuery | undefined,
  options?: { enabled?: boolean },
) {
  return usePermittedQuery({
    module: 'wallboard',
    action: 'access',
    queryKey: wallboardQueryKeys.list(params),
    queryFn: () => getSessionWallboard(params),
    staleTime: 15 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 45 * 1000,
    refetchOnWindowFocus: true,
    enabled: options?.enabled !== false,
  })
}
